import {
  CONTACT_FORM_REQUEST,
  CONTACT_FORM_SUCCESS,
  CONTACT_FORM_FAIL,
  CLEAR_ERRORS,
} from "../constant/contactFormConstants";
import axios from "axios";

export const createContactForm = (formData) => async (dispatch) => {
  try {
    dispatch({ type: CONTACT_FORM_REQUEST });

    const { data } = await axios.post(`/contact/create`, {
      ...formData,
    });
    console.log({ data });
    dispatch({ type: CONTACT_FORM_SUCCESS, payload: data.message });
    
  } catch (error) {
    dispatch({
      type: CONTACT_FORM_FAIL,
      payload: error.response.data.message,
    });
  }
};

// Clearing Errors
export const clearErrors = () => async (dispatch) => {
  dispatch({ type: CLEAR_ERRORS });
};
